import { useRef, useLayoutEffect } from "react"

const isServer = typeof window === "undefined"

const getScrollPosition = ({ element, useWindow }) => {
  if (isServer) return { x: 0, y: 0 }
  const target = element ? element.current || document.body : document.body
  const position = target.getBoundingClientRect ? target.getBoundingClientRect() : {}
  return useWindow ? { x: window.scrollX, y: window.scrollY } : { x: position.left, y: position.top, height: position.height }
}

const useScrollPosition = (effect, dependencies, element, stickyEl, useWindow, wait) => {
  const position = useRef(getScrollPosition({ useWindow }))
  const stickyPosition = useRef(getScrollPosition({ element: stickyEl }))
  let throttleTimeout = null

  const callBack = () => {
    const currPos = getScrollPosition({ element, useWindow })
    const currStickyPos = getScrollPosition({ element: stickyEl })
    effect({ prevPos: position.current, currPos, currStickyPos })
    position.current = currPos
    stickyPosition.current = currStickyPos
    throttleTimeout = null
  }

  useLayoutEffect(() => {
    const handleScroll = () => {
      if (wait) {
        if (throttleTimeout === null) {
          throttleTimeout = setTimeout(callBack, wait)
        }
      } else {
        callBack()
      }
    }
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, dependencies)
}

export const getStickyLowerCut = (withTitle = true) => (withTitle ? -33 : -37)
export const getFloatingTopLowerCut = (withTitle = true) => (withTitle ? -235 : -180)
export const getFloatingBottomUpperCut = (withTitle = true) => 750
export const getReachBottomLowerCut = (withTitle = true) => 540

export default useScrollPosition
